@for (item of cdkDropListData; track trackElement(index, item); let index = $index) {
  <div>
    <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ index: index }"></ng-container>
  </div>
}
